// =========================================================================
// Cache selectors for better performance
// =========================================================================
import { domReady } from "./functions/utility.js";

const hasCCM = document.querySelectorAll("[data-ccm-loader-group]");
const CCMopen = document.querySelector(".CCMopen");
const collapse = document.querySelector(".collapse");
const eyeAble = document.querySelector(".as-eyeable");
const flyoutSearch = document.querySelector("#search");
const lightbox = document.querySelector(".lightbox");
const modal = document.querySelector(".modal");
const navHandler =
  document.querySelector(".link-button") ||
  document.querySelector(".icon-button");
const panel = document.querySelector(".panel");
const swiper = document.querySelector(".swiper-container");
const teaserSlider = document.querySelector(".ctype-ce_isny_teaser_slider");
const videoModal = document.querySelector(".video-modal");
const powermailErrorHandler = document.querySelector(".ctype-powermail_pi1");

// =========================================================================
// Parallel imports
// =========================================================================
domReady().then(() => {
  const imports = [];
  if (hasCCM) {
    imports.push(import("./modules/ccm19.mjs").then((m) => m.init()));
  }
  if (CCMopen) {
    imports.push(import("./modules/ccmopen.mjs").then((m) => m.init()));
  }
  if (collapse) {
    imports.push(import("./modules/collapse.mjs").then((m) => m.init()));
  }
  if (eyeAble) {
    imports.push(import("./modules/eyeAble.mjs").then((m) => m.init()));
  }
  if (flyoutSearch) {
    imports.push(import("./modules/flyoutSearch.mjs").then((m) => m.init()));
  }
  if (lightbox) {
    imports.push(import("./modules/magnificPopup.mjs").then((m) => m.init()));
  }
  if (modal) {
    imports.push(import("./modules/modal.mjs").then((m) => m.init()));
  }
  if (navHandler) {
    imports.push(import("./modules/navHandler.js").then((m) => m.init()));
  }
  if (panel) {
    imports.push(import("./modules/panel.mjs").then((m) => m.init()));
  }
  if (swiper) {
    imports.push(import("./modules/swiper.mjs").then((m) => m.init()));
  }
  if (teaserSlider) {
    imports.push(import("./modules/teaserSlider.mjs").then((m) => m.init()));
  }
  if (videoModal) {
    imports.push(import("./modules/videoModal.mjs").then((m) => m.init()));
  }
  if (powermailErrorHandler) {
    imports.push(import("./modules/powermailA11y.mjs").then((m) => m.init()));
  }

  // =========================================================================
  // Execute all in parallel
  // =========================================================================
  if (imports.length) Promise.all(imports).catch(console.error);
});
